import React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import FooterEl from "../Footer/FooterEl";

import Header from "../header/Header";
import "./Terms.scss";
const TermsAndConditions = () => {
  return (
    <>
      <Header />
      <div className="headLine">
        <p className="textHeadline">Terms & Conditions</p>
        <div className="content">
          <p className="text">
            <strong>Last Updated: 29 May, 2025</strong>
            <br></br>
            <br></br>
            <strong>INTRODUCTION</strong>
            <br></br>
            <br></br>
            These terms and conditions of use (“Terms of Use”) along with other
            policies available on our platform forms a legally binding agreement
            between You and <strong>Shmania Games Private Limited </strong>
            (“Chatandmoney”, "chat&money", “Our”, “We”, “Us”).
            <br></br>
            <br></br>
            <strong>“Chatandmoney”, "chat&money" are one single entity.</strong>
            <br></br>
            <br></br>PLEASE READ THESE TERMS OF USE CAREFULLY BEFORE PLAYING ANY
            MOBILE GAMES OR/AND USING THE{" "}
            <strong>Chatandmoney / chat&money</strong> PLATFORM.
            <br></br>
            <br></br>
            <strong> 1.WHO WE ARE AND WHAT WE DO?</strong>
            <br></br>
            We are the flagship brand of{" "}
            <strong>Shmania Games Private Limited,</strong> offering Our
            Platform to You and an opportunity for You to participate in
            Contests spanning across a broad range of officially sanctioned
            real-time Questions asking to you friends (Second-user). An
            illustrative list of such categories and events is mentioned below
            as maybe modified from time to time (“Categories”):
            <br></br>
            <br></br>
            i. Science
            <br></br>
            ii. Sports
            <br></br>
            iii. History
            <br></br>
            iv. General Knowledge
            <br></br>
            v. Music
            <br></br>
            vi. Movies
            <br></br>
            vii. Thirds Party Questions
            <br></br>
            viii. Text , Image, Audio, Video Based Questions
            <br></br>
            <br></br>
            <br></br>
            Any person using, accessing and/or participating in any Question
            (SEND “OR” RECEIVE) and also related free-to-play online gaming
            contests (“Practice Questions”) and/or pay-to-play online gaming
            contests (“Paid Questions”) on Our Platform is a user (“User”). All
            references to “You/Your” relate to the User. All references to
            “We/Us/Our” relate to <strong> “CHATANDMONEY GAME APP”</strong>{" "}
            which denotes a collective reference to the Chatandmoney mobile
            application and the Chatandmoney website (hereinafter collectively
            referred to as “Platform”). Practice Questions and Paid Questions
            are herein after collectively referred to as{" "}
            <strong>“QUEST OR QUESTIONS”</strong>.<br></br>
            <br></br>
            <br></br>
            <strong>2. ACCEPTANCE OF OUR TERMS AND CONDITIONS</strong>
            <br></br>
            Your continued usage of Our Platform constitutes Your acceptance of
            the terms and conditions, including any additional terms that We may
            make available to You (<strong>“Terms"</strong>) and are
            contractually binding on You. You accept that in the event of any
            variance between these Terms and any additional terms relating to
            the usage of Our Platform or any Contest, the additional terms will
            prevail. By accepting these Terms, You agree and consent to receive
            communications from Us and/or Our partners, licensors or associates
            for any purpose through the following modes:
            <br></br>
            i. Announcements;
            <br></br>
            ii. Administrative messages/direct messages ;<br></br>
            iii. Advertisements;
            <br></br>
            iv. Direct notification to your account; and
            <br></br>
            v. by any other means that We may consider fit for this purpose.
            <br></br>
            <br></br>
            You agree that You shall mark Us as a safe sender on all Your
            platforms where You receive any such communications from Us
            (including via email and SMS) to ensure such communications are not
            transferred to the spam/junk folder.
            <br></br>
            <br></br>
            <strong>3. USER ACCOUNT</strong>
            <br></br>
            i. You are required to register on Our Platform to create an account
            to access Our Services (“Account”). At the time of creating Your
            Account and/or at any time during the utilisation of Our Services,
            You will be required to provide any and/or all of the following
            information and/or documents:
            <br></br>
            <br></br>
            1. Your full name;
            <br></br>
            2. Your unique username;(optional)
            <br></br>
            3. Your mobile number;
            <br></br>
            4. Your full address and state of residence;
            <br></br>
            5. Your gender; and
            <br></br>
            6. Your date of birth.
            <br></br>
            7. Aadhar number
            <br></br>
            8. Any other valid identification
            <br></br>
            9. Bank Account information
            <br></br>
            10. UPI ID
            <br></br>
            11. Permanent Account Number (PAN)
            <br></br>
            <br></br>
            We reserve the right to conduct KYC as may be required from time to
            time in the manner prescribed under such law. Some details can be
            entered or verify later in lieu of using the service of mobile game.
            <br></br>
            <br></br>
            <strong>4. ELIGIBILITY</strong>
            <br></br>
            <br></br>
            i. To SEND / RECEIVE any Paid Questions, you must meet the following
            eligibility criteria:
            <br></br>
            1. You must be above the age of 18 years.
            <br></br>
            2. You must be residing in India.
            <br></br>
            3. You must have a valid Indian mobile number to create an Account.
            <br></br>
            <br></br>
            ii. Please note that Paid Contests are not permitted in the
            following states (<strong>“Restricted States”</strong>):
            <br></br>
            1. Andhra Pradesh
            <br></br>
            2. Assam
            <br></br>
            3. Nagaland
            <br></br>
            4. Sikkim
            <br></br>
            5. Telangana
            <br></br>
            6. Jammu and Kashmir Ladakh  and
            <br></br>
            7. Ladakh
            <br></br>
            <br></br>
            iii. You agree that You are not from any of these Restricted States
            and You shall refrain from making any false disclosures,
            declarations and/or representations to Us to circumvent the
            applicable laws and/or regulations of the territory of India
            (“Applicable Law”) of the Restricted States to participate in any
            Paid Questions (Send / Receive).
            <br></br>
            <br></br>
            <strong>5. QUESTIONS SEND AND RECEIVE RULES AND FORMAT</strong>
            <br></br>
            You agree and acknowledge that:
            <br></br>
            1. To Send / Receive any paid Question(s), You are required to
            create an account by selecting category and select the amount and
            click send.
            <br></br>
            2. We reserve a right to deduct a fee from the Pre-Designated Amount
            in lieu of the Service being provided by Us (“Platform Fees”) and
            the balance amount shall constitute Your contribution towards the
            Prize Money. ("Prize Moneyl").
            <br></br>
            3. For clarity, it’s a one on one transparent game from money
            refrence..
            <br></br>
            4. From time to time, we may conduct/organize promotions/offers on
            the Platform. Your participation in such promotions/ offers shall be
            in accordance with the terms and conditions applicable to the
            Promotion.
            <br></br>
            5. You can spend a set limit of amount daily and per monthly it’s
            the limit set by the platform (Chatandmoney mobile game).
            <br></br>
            6. We rely on information/data received from third-party data feed
            service providers (“Data Feed Providers”) and/or publicly available
            information.
            <br></br>
            7. Prior to send Questions, We strongly recommend You conduct Your
            own independent research of questions authentic validity.
            <br></br>
            8. In Sending / Receiving, any Question(s). You agree to strictly
            comply with the Terms, including additional rules published by Us,
            such as:
            <br></br>
            (a) No, abusive or prohibited material used
            <br></br>
            (b) any other rules and regulations (including without limitation in
            relation to payments made to participate in any Questions send /
            receive).
            <br></br>
            <br></br>
            <strong>6. WINNING</strong>
            <br></br>
            <br></br>
            <strong>WINNER DECLARATION</strong>
            <br></br>
            1. Win are awarded based on the performance of Your Answer(s) Right
            / Wrong. Completely Fair Play and 100% transparent winning assured.
            <br></br>
            2. Timer based Questions, The Winner(s) will be selected based on
            the fastest correct answer, User(s)
            <br></br>
            3. The number of eligible winners in a group play contest will be
            awarded based on the game end (after all players have answered) on
            time due Questions that will be of maximum 24 hours.
            <br></br>
            <br></br>
            <strong>i. GENERAL RULES FOR DISTRIBUTION OF WINNINGS</strong>
            <br></br>
            1. The User accumulating the highest money can be withdrawal after
            the minimum amount limit reached only then the money can be Payout
            within 1-2 days (depend on banking usability) through chatandmoney
            mobile app.
            <br></br>
            2. If there is a tie, the winnings will be distributed evenly among
            the declared winners or that amount can be re-used for next
            Question(s)
            <br></br>
            3. We reserve the right to vary or modify the winnings at Our
            discretion before the Question(s) Deadline.
            <br></br>
            4. You agree that any winnings in the nature of rewards awarded by
            Us shall be governed by the terms and conditions of such specific
            promotional events.
            <br></br>
            5. We reserve the right to disqualify any Winner and prevent them
            from withdrawing their winnings or receiving any prize if:
            <br></br>
            a. any of the document or information submitted by You are
            incorrect, misleading, false, fabricated, incomplete or illegible;
            or
            <br></br>
            b. You created or played on behalf of other Users.
            <br></br>
            c. You do not abide by these Terms.
            <br></br>
            d. You have falsely declared your State and entered the contest from
            prohibited states as per clause IV above.
            <br></br>
            <br></br>
            <strong>ii. VERIFICATION OF WINNERS</strong>
            <br></br>
            1. We or our third-party service providers working on behalf of us
            may contact the Winners on the email address or mobile number
            provided at the time of Account creation. At this stage, Winner will
            be explained the details of the verification process and the
            documents required for collecting the money payout ( money
            withdrawal)
            <br></br>
            2. If You have been declared as a Winner on Our Platform but have
            not received Your Winnings, You may contact Our team using
            information given on the time of account creation within forty-eight
            (48) hours of the Winner declaration to help us resolve your concern
            at the earliest.
            <br></br>
            3. You agree and acknowledge that Our decision with respect to
            awarding the Winnings as per the Terms will be final and binding on
            You in all conditions.
            <br></br>
            <br></br>
            <strong>7. PAYMENT TERMS</strong>
            <br></br>
            The below terms govern all payment-related transactions made by You,
            and You agree to abide by them.
            <br></br>
            <br></br>
            <strong>PAYMENT ACCOUNTS</strong>
            <br></br>
            By accessing and using Our Platform, You are provided with the
            following categories of accounts for processing and reconciling Your
            payments:
            <br></br>
            <br></br>
            1.
            <strong>Winning Account</strong>- This account holds your winnings
            in any Paid Contests.
            <br></br>
            2.
            <strong>Play Winning Account</strong>- This is a sub-set of Your
            winnings account only and holds winning amount that You have
            selected to keep as Play Winnings. Play winnings are
            non-withdrawable, can be used to join Contests and do not expire.
            <br></br>
            <br></br>
            <strong>i. DISCOUNT OFFERED</strong>
            <br></br>
            1. In order to conduct promotional activities and provide
            incentives, We may issue discounts to You which may be utilised for
            sending and receiving any paid Question(s) (“Discount(s)”). You
            agree to the following :<br></br>
            <br></br>
            a. You shall not be permitted to transfer or withdraw any amount of
            Discounts offered to any other account including Your bank account.
            <br></br>
            b. The utilization of any Discount shall be subject to certain terms
            which will be notified to You at the time of issuance of any
            Discount.
            <br></br>
            c. Discount shall be issued at our sole discretion and will not be
            demanded as a matter of right.
            <br></br>
            d. Discount will be applied towards the Pre-designated Amount for
            sending and receiving Questions.
            <br></br>
            e. Upon termination of Your Account, all Discounts shall be
            forfeited and You shall not have any right or interest on such
            Discount.
            <br></br>
            f. Any Discount issued to you may take up to 24 hours to reflect in
            their respective Discount account as defined below. You agree not to
            hold Us responsible or liable for any delay, including any loss of
            opportunity to play send and receive any Question(s) due to delay in
            crediting the Discount.
            <br></br>
            g. In the event of any conflict between these Terms and the terms
            specific to the Discount, if any, the Discount terms shall prevail.
            <br></br>
            <br></br>
            <strong>2. We may offer the following Discounts</strong>
            <br></br>
            <br></br>
            <strong>a. Discount Coupons.</strong>
            <br></br>
            We may grant Discount coupons or free play at Our sole discretion
            and each Discount coupon shall be governed by the specific terms and
            conditions as notified by Us at the time of grant of such Discount
            coupons. You acknowledge that Discount coupons shall have their own
            validity and specific terms and conditions available on the
            Platform. In case of any conflict between these Terms and the terms
            specific to the Discount coupon, the terms specific to the Discount
            coupon shall prevail.
            <br></br>
            <br></br>
            <strong>ii. PRE - DESIGNATED AMOUNT PAYMENT</strong>
            <br></br>
            1. If You do not have enough balance in either of your Accounts to
            participate in any Paid Questions, You will need to remit the Amount
            required to play the Question(s). You agree that any amount
            deposited shall be subject to deduction of applicable GST in
            accordance with these Terms.
            <br></br>
            <br></br>
            <strong>iii. WITHDRAWALS PROCESSING</strong>
            <br></br>
            1. You will be prompted to provide certain documents for processing
            your payments and verification purposes at the time of your first
            withdrawal.
            <br></br>
            2. The name mentioned on the identification document as provided by
            You in the app should correspond with the name of the Bank Account
            holder of the Bank or linked to the UPI ID provided by You at the
            time of bank account or UPI verification at the time of withdrawal
            or bank account change request.
            <br></br>
            3. We will process your withdrawal after verifying your bank account
            details and/ or UPI ID (as applicable). Upon verification, we will
            debit the amount from your Winning Account and transfer it online to
            your bank account at the earliest.
            <br></br>
            4. The minimum amount that can be withdrawn via single transaction
            shall be communicated on the Chatandmoney mobile app’s withdrawal
            page.
            <br></br>
            5. We may charge any processing fee for the online transfer of funds
            from your Winning Account to Your bank account
            <br></br>
            6. We depend on banks and third parties to process transactions on
            Our Platform. Thus, we may take up to 24 hours to process any
            payments to Your bank account. You agree not to hold Us responsible
            or liable for any delay in processing any payments.
            <br></br>
            7. A transaction, once confirmed, is final, and no cancellation is
            permissible.
            <br></br>
            <br></br>
            <strong>i. TAXES PAYABLE</strong>
            <br></br>
            1. From 01 October 2023, 28% GST is applicable on the amount
            deposited by You in Your Account. You can view the GST paid on each
            deposit made by You in the Account on the ‘My Transaction’ page on
            the Platform. The GST value listed on the invoice shall be the final
            GST amount charged to You
            <br></br>
            2. All winnings shall be subject to deduction of tax (“TDS”) as per
            the Income Tax Act 1961. With effect from 1st April 2023, TDS of 30%
            shall be deducted from Net Winnings (“NW”) on each withdrawal
            request placed by You.
            <br></br>
            3. In the event, You do not withdraw any of Your winnings during a
            financial year and You have Net Winning balance as of 31 March of
            each year, then TDS of 30% shall be deducted on such Net Winnings
            balance from Your Winning Account or Unutilized Account as on 31
            March as calculated above.
            <br></br>
            4. In case of any revisions by the Government of India to the
            aforementioned rate or the definition of Net Winnings in the future,
            TDS will be deducted by Us in accordance with the then-current
            prescribed TDS rate and the revised definition of Net Winnings.
            Winners will be provided TDS certificates in respect of such tax
            deductions. The Winners shall be responsible for payment of any
            other applicable taxes, including but not limited to, income tax,
            gift tax, etc. in respect of the Net Winnings. We shall not in any
            manner be responsible for users' individual tax matters.
            <br></br>
            <br></br>
            <strong>v. REFUNDS</strong>
            <br></br>
            <br></br>
            1. We will refund any amount left in your Unutilised Account if your
            Account gets suspended or removed
            <br></br>
            (a) due to Our failure to provide Services,
            <br></br>
            (b) any instruction received from any government or regulatory
            authority
            <br></br>
            (c) any left balance in the user wallet will be refunded within 3-4
            days (business working days).
            <br></br>
            <br></br>
            2. We will refund the Pre-Designated Amount paid by You in case any
            Question or Quiz is abandoned in accordance with these Terms.
            <br></br>
            3. We shall deactivate Your Account pursuant to any direction issued
            by an appropriate government agency and/or competent authority. If
            We receive requisite instructions from such authority, We shall
            refund the deposited amount from Your main balance Account to the
            source account, subject to applicable processing fees.
            <br></br>
            4. In the event Our Services are not available due to reasons
            outside Our control, including but not limited to any failure to
            perform due to unforeseen circumstances or cause beyond Our control,
            such as acts of god, war, terrorism, riots, embargoes, acts of civil
            or military authorities, fire, floods, accidents, pandemic,
            epidemic, network infrastructure failures, strikes, or shortages of
            transportation facilities, fuel, energy, labor or materials or any
            cancellation of services available on Our Platform (each a “Force
            Majeure Event”), then We reserve the right to cancel any Play or
            Questions and Quiz and process refund of the Pre - Designated
            Amount.
            <br></br>
            5. In the event of a Paid Question(s) Contest involving up to 4
            Users, where all the Users have entered the same teams the
            Pre-Designated Amount shall be refunded to all the users after the
            Game starts. The refund shall be credited to the account from which
            the Pre-designated Amount was utilized. For a Paid Group Quiz
            Contest involving 5 or more Users, where all the Users have entered
            then the money shall be equally divided between the Users according
            tpo winners.
            <br></br>
            6. If there is any request for withdrawal of amount deposited in
            Main balance Account, such refund request shall be processed net of
            GST i.e. applicable 28% GST paid on the amount deposited in
            Unutilised Account. GST amount shall not be refunded as per
            applicable government laws.
            <br></br>
            7. If the user requested for a refund of any unused money (balance)
            it will be processed within 3-4 days (business working days).
            <br></br>
            <br></br>
            <strong>vi. USER FUNDS</strong>
            <br></br>
            1. You hereby authorise Us to appoint an independent third-party/
            trustee/ escrow agent to act on your behalf in a fiduciary capacity
            (“Third Party”) with respect to holding any amount belonging to You
            and undertaking actions, consents, approvals and any other requisite
            instructions necessary for such amount.
            <br></br>
            <br></br>
            2. You acknowledge that
            <br></br>
            a. We do not hold any right, title and/or interest in the Prize
            Money.
            <br></br>
            b. the amount deposited by You will be used only for participation
            in the Paid Questions and/or any other gaming related value-added
            services availed.
            <br></br>
            c. any amount deposited by You, shall not be forfeited by Us except
            in case where We receive an instruction from any government agency
            or competent authority.
            <br></br>
            <br></br>
            3. You further authorize Us to instruct the Third Party to open a
            bank account(s) which will be used for including but not limited to
            the following payouts:
            <br></br>
            a. withdrawal of Your winnings;
            <br></br>
            b. payment of Platform Fee;
            <br></br>
            c. payment of taxes as applicable towards TDS on Net Winnings; and
            <br></br>
            d. Government (toward GST payable)
            <br></br>
            e. payments towards any other gaming related value added services
            offered by Us.
            <br></br>
            <br></br>
            <strong>8. YOUR CONDUCT</strong>
            <br></br>
            In using and accessing Our Platform, You agree to observe the
            following code of conduct:
            <br></br>
            <br></br>
            <strong>ACCOUNT INFORMATION</strong>
            <br></br>
            a. You are permitted to create only one Account on Our Platform.
            When creating Your Account with Us (or updating Your Account
            information), You agree that You will provide true, accurate and
            updated information and documentation. You will not provide any
            false and/or incorrect information and documentation nor impersonate
            or attempt to impersonate and/or otherwise assume the identity of
            another person without due authority. You will not commit any such
            fraudulent act which amounts to forgery and/or involves the
            fabrication of documentation.
            <br></br>
            b. You agree and acknowledge that the address-related details
            provided by You shall be treated as Your{" "}
            <strong>“Address on record” for the</strong>
            purposes of the Goods and Service Tax Act.
            <br></br>
            c. You agree that You shall promptly update your Account related
            details on Our Platform in the event of any change in such details
            and/or write to Our contact Us page in the Chatandmoney mobile app
            in the event of any; a) change in Your Account related details
            and/or; b) any unauthorised use of Your Account to enable us to take
            remedial action.
            <br></br>
            <br></br>
            <strong>1. MAINTAIN CONFIDENTIALITY</strong>
            <br></br>
            <br></br>
            You will maintain the confidentiality of all information relating to
            Your Account, and You will not share Your One Time Password (“OTP”)
            with any other person;
            <br></br>
            a. You will not engage in any fraudulent conduct in logging into
            another user’s account by asking for their account-related
            information or taking their OTP.
            <br></br>
            <br></br>
            <strong>2. COMPLIANCE WITH APPLICABLE LAW</strong>
            <br></br>You agree to comply with Applicable Laws.
            <br></br>
            a. You agree that You shall not commit any illegal act that disrupts
            Our systems.
            <br></br>
            <br></br>
            <strong>3. VIOLATION OF PLATFORM TERMS</strong>
            <br></br>
            You shall not engage in any Fair Play Voilation terms;
            <br></br>
            a. You shall not violate any of the Terms in using and accessing Our
            Platform and Services;
            <br></br>
            b. You shall not misuse any Discount and/or any other offers or
            promotions given by Us.
            <br></br>
            c. You agree that you shall use the Platform and Our Services solely
            in Your personal capacity, and You will not engage in malpractices
            or collude with other Users in deriving any benefit and/or running
            any business in connection with the use of Our Platform and/or
            Services.
            <br></br>
            d. You shall not be engaged in any form of insider trading, i.e.
            illegally sharing and seeking non-public information, knowledge of
            participating teams in any given contests, Quest Play, strategies,
            organizing boards, leagues etc. which may give You an unfair
            competitive advantage. (<strong>"Insider Trading"</strong>)<br></br>
            e. You shall not tamper, modify, or otherwise deal with our data,
            content, software, technology and/or Intellectual Property by any
            means.
            <br></br>
            <br></br>
            <strong>4. RESPONSIBLE PLAY</strong>
            <br></br>
            We're committed to fostering responsible gaming for all our users.
            You agree to participate in the Contests responsibly by making
            informed decisions and playing within Your means. You are encouraged
            to seek help if needed.
            <br></br>
            <br></br>
            <strong>5. ADDITIONAL FEATURES</strong>
            <br></br>
            We offer Our Users additional features on our platform
            <br></br>
            <br></br>
            <strong>
              Questing is a feature used for sending and receiving Questions
              with other users (friends and family).
            </strong>
            <br></br>
            <strong>Chat Feature: </strong> is a tool that allows You to
            communicate with each other in real-time on the Platform either in a
            public or private setting (“Chat Feature”). You agree to observe the
            following code of conduct:
            <br></br>
            i. You shall not engage in illegal, obscene, abusive, offensive,
            racially insensitive, communal, objectionable, defamatory, or
            otherwise inappropriate and immoral conduct
            <br></br>
            ii. You shall not harass, bully, stalk, threaten, or otherwise
            violate any rights of other Users;
            <br></br>
            iii. You shall be responsible for all content published,
            contributed, and made available by You on Our Platform. This
            includes any content You share with Us (“User Content/Your
            Content”).
            <br></br>
            iv. Your Content shall not be immoral, profane, defamatory, or
            offensive;
            <br></br>
            v. You shall not use Our Platform for advertising, offering or
            selling any goods or services for commercial gain except with Our
            prior written consent;
            <br></br>
            vi. You shall not restrict or inhibit any other User from using Our
            Platform;
            <br></br>
            vii. You shall not publish any content on Our Platform which is
            patently false, with the intent to mislead or harass any person or
            third party, whether for financial gain or to cause any injury to
            any person or otherwise;
            <br></br>
            viii. You shall not collude with any other User(s) or engage in
            syndicate play;
            <br></br>
            ix. You agree that such behaviour qualifies as User misconduct.
            <br></br>
            x. You shall not spam other User(s) by sending any unsolicited
            communications;
            <br></br>
            xi. You will not collect, store, or obtain any information about
            other Users without their prior written consent;
            <br></br>
            xii. You shall not engage in any action that threatens the unity,
            integrity, defence, security or sovereignty of India, friendly
            relations with foreign States, or public order, or causes incitement
            to the commission of any cognisable offence or prevents
            investigation of any offence or is insulting other nations
            <br></br>
            <br></br>
            A.{" "}
            <strong>
              CMcoin - By participating on our Platform and engaging in specific
              actions such as participating in a Contest, You will be awarded
              CMcoins for Your participation subject to Your compliance with the
              terms and conditions provided.
            </strong>
            <br></br>
            <br></br>
            <strong>9. OUR RIGHTS AND OBLIGATION</strong>
            <br></br>
            <br></br>
            <strong>YOUR CONTENT</strong>
            <br></br>
            We reserve our rights to remove (without notice) any
            offending/illegal/objectionable/ infringing content posted by You
            and take such necessary action as We may consider appropriate
            concerning Your Content;
            <br></br>
            <br></br>
            <strong>i. CONTEST</strong>
            <br></br>
            We may choose to:
            <br></br>
            1. Revise the roster of players available for selection in relation
            to any Contest/Quiz play offered on Our Platform based on the
            official information We may receive from the sports organiser or any
            third-party sources.
            <br></br>
            2. Withdraw and/or cancel any Contest without prior notice to You
            should the carrying on of such Contest be prohibited and/or require
            any governmental, statutory or regulatory compliances or approvals;
            <br></br>
            <br></br>
            3. Adjust the Contest Deadline or Abandon any Contest.
            <br></br>
            a. We reserve the right to abandon a Contest/Question(s) upon the
            occurrence of circumstances beyond Our reasonable control.
            <br></br>
            <br></br>
            <strong>ii. OUR SERVICES</strong>
            <br></br>
            We may choose to
            <br></br>
            1. Change, discontinue or suspend all or any part of Our Service;
            <br></br>
            2. Suspend or terminate Your Account as directed by an appropriate
            government agency and/or competent authority.
            <br></br>
            <br></br>
            <strong>iii. BREACH OF TERMS</strong>
            <br></br>
            <br></br>
            In case of breach of these Terms or if We reasonably believe that
            You have breached these Terms, We may choose to:
            <br></br>
            1. Restrict, suspend, deactivate or permanently delete Your account
            with Us (including all related information that You might have
            provided to Us)
            <br></br>
            2. Disqualify You from participating in a Contest;
            <br></br>
            3. refrain from awarding any prizes to You or forfeit Your winnings
            <br></br>
            4. initiate appropriate civil/criminal proceedings as We may
            consider appropriate in addition to forfeiture and/or recovery of
            prize money.
            <br></br>
            <br></br>
            <strong>10. INTELLECTUAL PROPERTY RIGHTS</strong>
            <br></br>
            <br></br>. You agree that We (including Our partners, licensors
            and/or associates) own all intellectual property rights in and to
            the software underlying the creation of Our Platform, including all
            material and content published by Us on Our Platform, which includes
            (but is not limited) to the following:
            <br></br>
            1. Our Contests
            <br></br>
            2. Our software/technology
            <br></br>
            3. Our advertisements
            <br></br>
            4. Our written/published content
            <br></br>
            5. Our images, graphics, photographs, illustrations
            <br></br>
            6. Our marks, logos, trade name
            <br></br>
            7. Audio and visual clippings used and published by Us
            <br></br>
            8. Flash animation (
            <strong>“Our Intellectual Property Rights/Our Content”</strong>)
            <br></br>
            <br></br>
            i. You agree that in accessing Our Intellectual Property Rights, You
            shall not do the following without Our prior written consent:
            <br></br>
            1. Modify, distribute, publish, transmit, reproduce, or otherwise
            deal with Our Intellectual Property Rights; or
            <br></br>
            2. Create derivative works of Our Intellectual Property Rights or in
            any way exploit Our Intellectual Property Rights.
            <br></br>
            <br></br>
            ii. You agree that:
            <br></br>
            1. You own all the intellectual property rights in Your content;
            <br></br>
            2. Your content will not result in any infringement claims from any
            third party; and
            <br></br>
            3. We are not liable for any of Your content shared and/or
            contributed by You on Our Platform.
            <br></br>
            <br></br>
            iii. You grant us a worldwide, non-exclusive, royalty-free,
            sublicensable, irrevocable, and transferable license to use Your
            content for the following:
            <br></br>
            1. use, reproduce, distribute, publish, and transmit Your content;
            and
            <br></br>
            2. otherwise, create any derivative works of the User Content for
            the following purposes:
            <br></br>
            <br></br>iv. display of User Content on Our Platform;
            <br></br>
            1. distribution and/or storage of User Content (either
            electronically or via other media) for any purpose; and
            <br></br>
            2. storing Users' Content in a remote database accessible by Users,
            for a charge
            <br></br>
            <br></br>
            <strong>11. PRIVACY POLICY</strong>
            <br></br>
            <br></br>
            All Your personal information collected (including financial data)
            is subject to Our Privacy Policy, which is available at Privacy
            Policy Page. You are encouraged to review this Privacy Policy to
            understand the data we collect and the purpose for which such data
            is collected.
            <br></br>
            <br></br>
            <strong>12. GRIEVANCE REDRESSAL MECHANISM</strong>
            <br></br>
            In case you have any complaints or grievance pertaining to (i) any
            User Content that You believe violates these Terms including any
            infringement of Intellectual Property Rights, (ii) Your access to
            the Platform, please share the same with Us by writing to:
            grievance.chatandmoney@gmail.com. On receiving such a complaint,
            grievance or notice, the grievance officer may reach out to You to
            seek further clarification, or to verify Your complaint. The name
            and title of the Grievance Redressal Officer are as follows:
            <br></br>
            <br></br>
            Chatandmoney Teams
            <br></br>
            Email: grievance.chatandmoney@gmail.com
            <br></br>
            Address: Shmania Games Private Limited,
            <br></br>
            Unit : 40/45 Shiv Shakti Nagar Meerut U.P. India
            <br></br>
            <br></br>
            The Grievance Officer identified above is pursuant to the provisions
            of Applicable Laws including but not limited to the Information
            Technology Act, 2000 and the Consumer Protection Act, 2019, and the
            Rules enacted under those laws. The Company reserves the right to
            replace the Grievance Redressal Officer at its discretion through
            the publication of the name and title of such replacement on the
            website, which replacement shall come into effect immediately upon
            publication.
            <br></br>
            You agree that regardless of any statute or law to the contrary, any
            complaints or grievances arising out of or related to the use of Our
            Platform or these Terms should be filed within thirty (30) days of
            such claim to enable us to resolve Your complaint at the earliest.
            <br></br>
            <br></br>
            <strong>13. LEGALITY</strong>
            <br></br>
            All game Play offered by Us on our platform is a game of skill and
            Knowledge skills and a legally and constitutionally protected
            business not amounting to betting, gambling and wagering held by the
            Supreme Court of India and different High Courts of India in
            multiple judgments.
            <br></br>
            These Contests require You to use Your knowledge, judgement and
            expertise to primarily determine Your success in such Contests
            rather than relying on chance.
            <br></br>
            <br></br>
            <strong>14. PUBLICITY</strong>
            <br></br>
            By accepting a prize, You grant Us and Our affiliates an
            irrevocable, royalty-free, worldwide, perpetual license to use Your
            name, likeness, image, voice and comments/ testimonials for any
            purpose, including but not limited to advertising and promotional
            purposes in any media.
            <br></br>
            We may organize promotional activities for which We may require Your
            presence. We will communicate the details of these activities to
            You. These promotional activities may include press events, internal
            meetings and ceremonies/functions.
            <br></br>
            <br></br>
            <strong>15. LIMITATION OF LIABILITY AND INDEMNIFICATION</strong>
            <br></br>. By accessing Our Platform, You hereby agree to indemnify
            Us and/ or any of Our directors, employees, partners, affiliates,
            associates and licensors (“Representatives”) against all liability,
            cost, loss, claims or expense arising out of Your access to Our
            Platform, arising due to any negligence on Your part and/ or any
            illegal act on Our Platform and/ or non-compliance with these Terms.
            <br></br>
            <br></br>
            i. Neither We nor Our partners, affiliates, licensors or associates
            shall be liable for any direct, indirect, incidental, special, or
            consequential damages arising out of Your use of or inability to use
            Our Services, even if We have been advised of the possibility of
            such damages.
            <br></br>
            ii. You, with this, waive each and every right You may have against
            Us and/ or Our Representatives for any injuries, accidents, or other
            events that may occur as a result of You accessing Our Platform,
            participating in Contests, or receiving Contest prizes. This waiver
            includes any known or unknown, anticipated or unanticipated events.
            <br></br>
            <br></br>
            <strong>16. GOVERNING LAW AND DISPUTE RESOLUTION</strong>
            <br></br>
            <br></br>. The District courts shall have exclusive jurisdiction to
            determine any and all disputes related to Our Services [(including
            the Contest(s)] (“Dispute”) and grant interim relief in any Dispute
            referred to arbitration as given below. Any Dispute will be governed
            by the laws of the Republic of India.
            <br></br>
            i. If there is a legal Dispute, the party raising the Dispute must
            send a written notification (“Notification”) to the other party. The
            parties will then try to resolve the Dispute through amicable
            discussions. Suppose the dispute remains unresolved within fifteen
            (15) days of receiving the Notification, in that case, the dispute
            will be settled through arbitration. We will appoint a sole
            arbitrator to conduct the arbitration proceedings in English as per
            the provisions of the Arbitration and Conciliation Act, 1996, as
            amended from time to time. The seat and venue of arbitration shall
            be Mumbai , Uttar Pradesh , New Delhi.
            <br></br>
            ii. The arbitration award will be final and binding on the parties.
            Each party will pay for the costs of arbitration and equally share
            the arbitrator's fees unless the arbitral tribunal decides
            otherwise. The arbitrator can pass interim orders and awards,
            including orders for specific performance, and such orders would be
            enforceable in competent courts. The arbitrator shall give a
            reasoned award.
            <br></br>
            iii. Nothing contained in these Terms shall restrict Us from seeking
            and obtaining interim or permanent equitable or injunctive relief or
            any other relief available to safeguard Our interest prior to,
            during or following the filing of arbitration proceedings or pending
            the execution of a decision or award in connection with any
            arbitration proceedings from any court having jurisdiction to grant
            the same. The pursuit of equitable or injunctive relief shall not
            constitute a waiver on Our part to pursue any remedy for monetary
            damages through the arbitration described herein.
            <br></br>
            <br></br>
            <strong>17. OTHER TERMS</strong>
            <br></br>
            <br></br>. These Terms govern Your use of Our Platform and Services
            and supersede any prior agreements that You may have with Us.
            <br></br>
            i. Our failure to exercise or enforce any right or provision of
            these Terms shall not constitute a waiver of such right or
            provision.
            <br></br>
            ii. In the event any of the provisions of these Terms are held to be
            invalid, illegal or unenforceable by any competent authority for any
            reason, the remaining portions of these Terms, if capable of
            substantial performance, will remain in full force and effect.
            <br></br>
            iii. Our employees are not eligible to participate in any paid
            Public Contest, which is a Public Contest.
            <br></br>
            iv. You acknowledge that You may be subject to additional terms that
            govern your transactions on Our Platform. You agree that if there is
            any conflict between these terms and the additional terms, the
            additional terms will prevail.
            <br></br>
            v. We may assign our rights and liabilities in relation to the
            Services offered by Us to any entity as we may deem fit in course of
            our business activity.
            <br></br>
            <br></br>
            <strong>18. DISCLAIMERS</strong>
            <br></br>. We will not be liable for any delay or failure to render
            the Services resulting from any Force Majeure Event.
            <br></br>
            i. You may access Our Platform at Your own risk. We are not
            responsible or liable for any loss or damage (including injuries,
            death, or loss of property) that You or anyone else may suffer while
            accessing Our Platform.
            <br></br>
            ii. You agree that Our Platform may contain third-party
            advertisements and links to websites/services owned and operated by
            Our affiliates and/ or third parties (“Third Party Content”). We do
            not endorse the Third Party Content or services of any third parties
            included on Our platform. We cannot guarantee the accuracy,
            reliability or quality of such Third Party Content. Your reliance on
            Third Party Content is at Your own risk. Any claims that You have
            regarding Third-Party Content should be directed to the third party
            in question.
            <br></br>
            iii. We will not be held responsible for any issues with the
            storage, deletion, delivery, or accessibility of information or
            materials to the extent allowed by law.
            <br></br>
            iv. We do not provide any warranty for Our Content, which is
            provided on an "as is, as available basis”.
            <br></br>
            v. We are not responsible for any errors or inaccuracies in the team
            starting line-up data provided on Our Platform, as it is obtained
            from external sources or publicly available information.
            <br></br>
            vi. We are not responsible for any inaccuracies in calculating
            fantasy points or the selection of winners due to inaccurate or
            incomplete information received from any third-party service
            provider.
            <br></br>
            vii. We make no representations or warranties regarding the quality,
            suitability or merchantability of any prizes and are not liable with
            respect to the same.
            <br></br>
            viii. We will not be liable for your inability to access Our
            Platform for any reason beyond our control such as network outage,
            telecommunication failure, internet suspension,virus, malware etc.
            <br></br>
            ix. We are not responsible for any errors in communication, or
            omissions in communication, including any errors made by You, which
            may prevent the results from being communicated to You.
            <br></br>
            x. We are not liable for any consequences arising from You sharing
            any confidential information including but not limited to OTP with
            any other person.
            <br></br>
            <br></br>
          </p>
        </div>
      </div>
      <FooterEl />
    </>
  );
};

export default TermsAndConditions;
